import React from 'react'

type Step = { id: number; title: string }

const defaultSteps: Step[] = [
  { id: 1, title: 'Grade' },
  { id: 2, title: 'Subject' },
  { id: 3, title: 'Details' },
  { id: 4, title: 'Questions' },
  { id: 5, title: 'Chapter & Explanation' },
]

// Renders a pill-style stepper with chevron separators. Completed pills are dark with a white check,
// the active/current pill is purple outlined, upcoming pills are white with border. This layout
// mirrors the requested visual: dark completed pill, purple outlined current, white upcoming.
const ExamProgressStepper: React.FC<{ current: number; steps?: Step[] }> = ({ current, steps = defaultSteps }) => {
  const clamp = Math.max(1, Math.min(steps.length, current))

  return (
    <div className="w-full mb-6">
      <div className="flex items-center justify-center gap-2">
        {steps.map((s, idx) => {
          const completed = s.id < clamp
          const active = s.id === clamp
          return (
            <React.Fragment key={s.id}>
              <div className="flex items-center">
                <div className={`flex items-center justify-center h-11 w-11 rounded-full font-semibold text-sm relative ${completed ? 'bg-slate-900 text-white' : active ? 'bg-white text-slate-900 ring-2 ring-purple-500' : 'bg-white text-slate-800 border border-gray-200'}`}>
                  {completed ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 8.757a1 1 0 011.414-1.414L8 10.636l6.293-6.293a1 1 0 011.414 0z" clipRule="evenodd"/></svg>
                  ) : (
                    <span>{s.id}</span>
                  )}
                </div>
                <div className="ml-3 text-xs text-center">
                  <div className={`font-medium ${completed ? 'text-slate-900' : active ? 'text-purple-600' : 'text-gray-500'}`}>{s.title}</div>
                </div>
              </div>

              {/* chevron separator except after last */}
              {idx < steps.length - 1 && (
                <div className="flex items-center px-2">
                  <svg className={`h-6 w-6 ${completed ? 'text-slate-900' : 'text-gray-300'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default ExamProgressStepper
